"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("../../common");
var BaasicArticleUtility = /** @class */ (function () {
    function BaasicArticleUtility() {
        this.utility = new common_1.Utility();
    }
    BaasicArticleUtility.prototype.replaceDiacritics = function (str) {
        for (var letter in common_1.ALPHABET) {
            str = str.replace(common_1.ALPHABET[letter], letter);
        }
        return str;
    };
    BaasicArticleUtility.prototype.toSlug = function (str) {
        if (this.utility.isUndefined(str) || str === null || str === '') {
            return str;
        }
        str = this.replaceDiacritics(str);
        str = str.toLowerCase();
        str = str.replace(/[^a-z0-9]+/g, '-');
        str = str.replace(/^-|-$/g, '');
        return str;
    };
    BaasicArticleUtility.prototype.updateSlug = function (resource) {
        var newSlug = this.toSlug(resource.slug);
        if (this.utility.isUndefined(newSlug) || newSlug === null || newSlug === '') {
            newSlug = this.toSlug(resource.title);
        }
        if (!this.utility.isUndefined(newSlug) || newSlug !== null || newSlug !== '') {
            if (resource.slug !== newSlug) {
                resource.slug = newSlug;
            }
        }
    };
    return BaasicArticleUtility;
}());
exports.BaasicArticleUtility = BaasicArticleUtility;
